import { combineReducers } from 'redux';
import questionsReducer from './questionsReducer';

const rootReducer = combineReducers({
  questionsReducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
